import React, { FC } from "react";
import { Stack } from "@mui/material";

import {
  Callout,
  CardGrid,
  Headline,
  Paragraph,
  Profile,
} from "@components/Content";
import {
  HeadlineProps,
  ParagraphProps,
  CalloutProps,
  ProfileProps,
  CardGridProps,
} from "@components/Content/types";

type CaseStudySection =
  | CardGridProps
  | HeadlineProps
  | ParagraphProps
  | CalloutProps
  | ProfileProps;

interface Props {
  sections: Array<CaseStudySection>;
}

const CaseStudy: FC<Props> = ({ sections }) => {
  return (
    <Stack>
      {sections.map((section: CaseStudySection, idx) => {
        const sectionKey = `article-section-${idx}`;

        if (section.type === "paragraph") {
          return <Paragraph content={section.content} key={sectionKey} />;
        } else if (section.type === "headline") {
          return (
            <Headline
              content={section.content}
              link={sectionKey}
              key={sectionKey}
            />
          );
        } else if (section.type === "callout") {
          return <Callout content={section.content} key={sectionKey} />;
        } else if (section.type === "cards") {
          return <CardGrid {...section} key={sectionKey} />;
        } else if (section.type === "profile") {
          return (
            <Profile
              name={section.name}
              title={section.title}
              image={section.image}
              key={sectionKey}
            />
          );
        }
      })}
    </Stack>
  );
};

export default CaseStudy;
